import TicketType from './ticket.type';
import Coupon from './coupon';
import { CardType } from '../enums/cardType.enum';
import { OrderStatus } from '../enums/orderStatus.enum';

export default interface OrderDetails {
  id: number;
  buyerName: string;
  buyerEmail: string;
  createdAt: Date;
  event: EventData;
  tickets: TicketData[];
  cancelledTickets: TicketData[];
  free_event: boolean;
  slug: string;
  status: OrderStatus;
  insurance_fee: number;
  sub_total: number;
  total: number;
  cardType: CardType;
  serviceFee: number;
  authorization: string;
  creditCard: string;
  discounts: {
    discount: number;
    discounted: number;
    discount_code: string;
    coupon: Coupon;
  }[];
}

export interface EventData {
  id: number;
  ticketsComments: string;
  name: string;
  startAt: Date;
  endAt: Date;
  place: string;
  link: string;
  cover?: Cover[];
}

export interface Cover {
  id: number;
  name: string;
  url: string;
}

export interface TicketData {
  id: number;
  label: string;
  checkInDate: Date | null;
  ticketType: TicketType;
  isSeat: boolean;
  qrcode: string;
  price?: number;
  gift: any;
  status: string;
}
